import React from "react";
import "./styles.css";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, containerClassName = "", className = "", ...props }, ref) => {
    return (
      <div className={`textarea-container ${containerClassName} ${error ? "textarea-container--error" : ""}`}>
        {label && <label className="textarea-label">{label}</label>}
        <textarea ref={ref} className={`textarea ${className}`} {...props} />
        {error && <span className="textarea-error">{error}</span>}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export default Textarea;

